<template>
  <nav-bar title="钢瓶列表" />
  <Content :bottom="0">
    <!-- 列表为空 -->
    <ul class="code-list" v-if="!list.length">
      <van-empty
        class="custom-image"
        :image-size="50"
        image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
        description="空空如也"
      />
    </ul>
    <ul class="code-list">
      <li v-for="item in list" :key="item.gsId" class="code-list-item"  >
        <div class="code-list-item__title" >{{item.gsCode}}</div>
        <van-button @click="$router.push(`/cylinderInfo/${item.gsCode}`)">详细</van-button>
      </li>
    </ul>
  </Content>
</template>

<script>
import { getCustomerTypeMessInfolist } from '@/api/cylinderInfo'
import { useGetData } from '@/hooks/useGetData'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
export default {
  name: 'CylinderListByIdAndType',
  props: ['id', 'type'],
  setup(props) {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const list = ref([])
    useGetData(getCustomerTypeMessInfolist, data => {
      list.value = data
    })({ userId: props.id || companyId.value, type: props.type })
    return { list }
  }
}
</script>

<style lang="scss" scoped>
.code-list {
  padding: 16px 16px 0 16px;
  .code-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    &__title {
      flex: 1;
      margin-right: 10px;
    }
  }
}
</style>
